<form [formGroup]="service.playerAtletiForm" (submit)="onSubmit()">
  <h1 mat-dialog-title>Player selection</h1>
  <mat-dialog-content>
    <div class="wrapper">
      <!--Form player-->
      <mat-form-field>
        <mat-label>Jugador</mat-label>
        <input cdkFocusInitial matInput #playerInput placeholder="Select player" formControlName="player" (keydown.enter)="handleEnter($event, playerAuto)"
            [matAutocomplete]="playerAuto" (input)="filter(playerInput)" (focus)="filter(playerInput)">
        <mat-autocomplete #playerAuto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onPlayerSelected(playerInput)">
            <mat-option *ngFor="let player of filteredPlayers" [value]="player">{{player?.name}}</mat-option>
        </mat-autocomplete>
      </mat-form-field>
      
      <!--Form add season-->
      <mat-form-field>
        <mat-label>Homegrown</mat-label>
        <mat-select formControlName="homegrown" required>
          @for (homegrown of homegrownOptions; track homegrown) {
              <mat-option [value]="homegrown">{{homegrown}}</mat-option>
            }
      </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="warn" mat-dialog-close (click)="service.playerAtletiForm.reset()">Cancel</button>
    <button mat-button submitButton type="submit" cdkFocusInitial>Add</button>
  </mat-dialog-actions>
</form>